import { z } from "zod";

/**
 * SÖZLEŞME PAKETİ GÜVENLİ DIŞA AKTARMA (CLOS-234 `[198]`).
 *
 * `auditExport` ile AYNI durum makinesi ve teslim deseni (`modules/audit/export.ts`) —
 * kart bunu açıkça ayırıyor: *"CLOS-194 ... bu kartın genel güvenlik veya audit
 * altyapısı DEĞİLDİR."* Ortak olan şey desendir (kuyruklu hazırlama, güvenli geçici
 * depolama, kısa ömürlü bilet), gerçek KAYNAK farklıdır — bu kart audit logu değil,
 * sözleşme içeriği paketler.
 */
export const CONTRACT_EXPORT_STATUSES = [
  "pending",
  "processing",
  "ready",
  "failed",
  "cancelled",
  "expired",
] as const;
export type ContractExportStatus = (typeof CONTRACT_EXPORT_STATUSES)[number];

export const CONTRACT_EXPORT_CONTENT_CLASSES = [
  "mainDocument",
  "versions",
  "attachments",
  "metadata",
  "comments",
  "activitySummary",
] as const;
export type ContractExportContentClass = (typeof CONTRACT_EXPORT_CONTENT_CLASSES)[number];

/**
 * SEÇİM GİRDİSİ — kart: *"kullanıcı yalnız erişebildiği ve export edilmesine izin
 * verilen içerikleri seçebilir"* ve *"her sözleşmede bütün içerik türlerinin bulunması
 * gerekmez; seçilmeyen veya bulunmayan içerik paketi bloke etmez."*
 */
export const contractExportRequestSchema = z.object({
  includeMainDocument: z.boolean().default(false),
  versionIds: z.array(z.uuid()).max(50).default([]),
  attachmentIds: z.array(z.uuid()).max(100).default([]),
  includeMetadata: z.boolean().default(false),
  /** Yalnız `visibilityScope = 'shared'` yorumlar değerlendirilir — iç özel yorum GİRMEZ. */
  includeComments: z.boolean().default(false),
  /** Sözleşme Aktivite geçmişinin (CLOS-281) güvenli özeti — audit logu DEĞİL. */
  includeActivitySummary: z.boolean().default(false),
});
export type ContractExportRequestInput = z.infer<typeof contractExportRequestSchema>;

export const contractExportParamsSchema = z.object({ id: z.uuid(), exportId: z.uuid() });

/** Manifest — hassas İÇERİĞİ taşımaz, yalnız hangi kaynağın pakete girdiğini. */
export type ContractExportManifestEntry = {
  id: string;
  kind: ContractExportContentClass;
  sourceId: string | null;
  fileName: string | null;
  sha256: string | null;
};

export type ContractExportManifest = {
  packageVersion: 1;
  contractId: string;
  generatedAt: string;
  includedClasses: ContractExportContentClass[];
  excludedClasses: ContractExportContentClass[];
  entries: ContractExportManifestEntry[];
};

export type ContractExportView = {
  id: string;
  contractId: string;
  status: ContractExportStatus;
  selection: ContractExportRequestInput;
  manifest: ContractExportManifest | null;
  failureReason: string | null;
  requestedAt: string;
  completedAt: string | null;
  expiresAt: string | null;
};
